import { useLazyQuery, useMutation } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { NewsWallConfirmed } from '../../models/NewsWall';
import { ProfileQL } from '../../models/Profile';
import { graphqlSchema } from '../../services/graphql.schema';

import Modal from 'react-modal';

import './NewsWall.scss';
import Button from '../Forms/Button';

interface NewsWallProps {
    currentUser: ProfileQL;
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)',
        transform: 'translate(-50%, -50%)',
        border: `1px solid rgba(172, 46, 120, 0.25)`,
        borderRadius: `16px`,
        overflow:'visible',
        padding: `1.5rem 2.5rem 1.1875rem`
    }
};
Modal.setAppElement('#root');

function NewsWalls({ currentUser }: NewsWallProps) {

    const [newsConfirmations, setNewsConfirmations] = useState<NewsWallConfirmed[]>(null)

    const [fetchNewsConfirmation] = useLazyQuery(graphqlSchema.FISCALPOP.NOTIFICATONS.getNewsWallConfirmed, {
        onCompleted: ({ getNewsWallConfirmed }: { getNewsWallConfirmed: NewsWallConfirmed[] }) => {
            console.log(`getNewsWallConfirmed: `, getNewsWallConfirmed)
            setNewsConfirmations(getNewsWallConfirmed);
        },
        onError: (e) => {
            console.error(`Error fetching News Wall confirmations: `, e);
        },
        fetchPolicy: 'network-only'
    })

    const [_confirmNews] = useMutation(graphqlSchema.FISCALPOP.NOTIFICATONS.saveNewsWallConfirmed, {
        onCompleted: ({ saveNewsWallConfirmed }: { saveNewsWallConfirmed: NewsWallConfirmed }) => {
            setNewsConfirmations(newsConfirmations.concat([saveNewsWallConfirmed]))
        },
        onError: (e) => {
            console.error(`Error confirming news entry: `, e);
        }
    })

    useEffect(() => {
        if (currentUser?.amazonProfile?.mwsSelledId) {
            fetchNewsConfirmation()
        }
    }, [currentUser, fetchNewsConfirmation])


    const confirmNews = (newsId: string) => () => {
        _confirmNews({
            variables: {
                newsId: newsId
            }
        })
    }

    const renderCfdi4News = () => {
        const newsID = 'cfdi4'
        const isConfirmed = !!newsConfirmations.find(n => n.newsId === newsID)
        return (
            <Modal
                isOpen={!isConfirmed}
                shouldCloseOnEsc={false}
                shouldCloseOnOverlayClick={false}
                onRequestClose={confirmNews(newsID)}
                style={customStyles}
                overlayClassName={'_blockedOVerlay'}
                ariaHideApp={false}
                contentLabel="CFDI4 implementado"
            >
                <div id="newsEntry">
                    <h4>
                        Cambio a CFDI 4.0
                    </h4>
                    <p>
                        La nueva versión de FiscalPOP para Amazon utiliza CFDI 4.0
                    </p>
                    <p>
                        <b>Esta nueva versión aplica validaciones nuevas a los campos de Receptores</b>, incluyendo Nombre y Código Postal del Receptor.
                    </p>
                    <p>
                        Todas las plataformas cambiarán durante Febrero y Marzo para implementar esta nueva versión.
                    </p>
                    <p>
                        Si experimentas inconvenientes o problemas, no dudes escribirnos por medio de la sección de Soporte para atenderte a la brevedad.
                    </p>
                    <div className='actions'>
                        <Button primary={true} handleClick={confirmNews(newsID)}>
                            <span>Entendido</span>
                        </Button>
                    </div>
                </div>
            </Modal>
        )
    }

    if(!newsConfirmations) {
        return (
            <></>
        )
    }

    return (
        <>
            {renderCfdi4News()}
        </>
    )
}

export default NewsWalls;